"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const ReviewWorkFormScene_1 = __importDefault(require("@Scenes/WorkScenes/ReviewWorkFormScene"));
const ViewWorkHeader_1 = __importDefault(require("@Components/ViewWork/Headers/ViewWorkHeader"));
const contexts_1 = require("@App/contexts");
const navigation_1 = __importDefault(require("@App/navigation"));
const work_type_1 = require("@Components/ViewWork/work-type");
const EditFormSceneWrapper = (props) => {
    let workType;
    if (props.workType) {
        workType = props.workType;
    }
    else {
        const params = (0, react_router_dom_1.useParams)();
        const typeWork = params.typeWork || 'bulk';
        if ((0, work_type_1.isValidWorkType)(typeWork)) {
            workType = typeWork;
        }
        else {
            throw new Error('Invalid Work Type ' + typeWork);
        }
    }
    const { workStore, rightsholderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const workDraftFromLocal = workStore.workDraftLocal;
    if (!workDraftFromLocal) {
        return react_1.default.createElement(react_router_dom_1.Navigate, { to: navigation_1.default.rightholder.catalog.root(rightsholderStore.currentRightsholderId) });
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ViewWorkHeader_1.default, { work: workDraftFromLocal }),
        react_1.default.createElement(ReviewWorkFormScene_1.default, { workType: workType })));
};
exports.default = EditFormSceneWrapper;
